<template>
  <div class="core-ability">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">五大核心能力，全面覆盖业务关键需求</div>
        <div class="module-subtitle">结合行业特性，呈现能力在不同业务场景中的定制化解决方案</div>
      </div>
      <div class="module-body">
        <div class="ability-item" v-for="(item, index) in dataList" :key="index" :style="{ '--s': item.color[0], '--d': item.color[1], }">
          <div class="ability-item-title">{{ item.name }}</div>
          <div class="ability-item-text">{{ item.text }}</div>
          <div class="ability-item-num">{{ index + 1 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataList: [
        { color: ['#73B2FB', '#1D76FF'], name: '资质及业绩能力', text: '平台主导资质及业绩资源建设，根据项目类型持续补充，为合伙人赋能。' },
        { color: ['#63C9A4', '#02D8B7'], name: '服务团队能力', text: '以远低于市场均价，提供标书服务、投标询价服务、设计服务等多类服务，助力快速拿下项目。' },
        { color: ['#8B8CE8', '#5150EE'], name: '供应链能力', text: '近20年的供应链经验，拥有市场上绝大多数的优质供应商，同时，平台提供“助理采购”模式，让您采的更低、质量更高，更省心。' },
        { color: ['#F39A4A', '#F27F26'],  name: '金融能力', text: '平台资金均在您自己的银行账户中，保证您的资金安全。 平台提供合理的金融配套，满足您的各种资金需求。' },
        { color: ['#FCE5A0', '#FEBC62'], name: '解决方案能力', text: '平台提供各行业解决方案，帮助您拓展更多的可能性。' },
      ]
    }
  }
};
</script>

<style lang="less" scoped>
.core-ability {
  padding: 64px 0;

  .content-center {
    .module-body {
      margin-top: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .ability-item {
        width: 224px;
        height: 258px;
        padding: 32px 24px 0 30px;
        border-radius: 4px 4px 76px 4px;
        background-color: #fff;
        overflow: hidden;
        cursor: default;
        transition: transform 0.3s ease;
        position: relative;
        &::before {
          content: '';
          width: 6px;
          height: 100%;
          background-image: linear-gradient(to bottom, var(--s), var(--d));
          position: absolute;
          left: 0;
          top: 0;
        }

        .ability-item-title {
          font-family: @font-medium;
          font-size: 20px;
          transition: color 0.3s ease;
          position: relative;
          &::after {
            content: '';
            width: 25px;
            height: 5px;
            background-image: linear-gradient(to left, var(--s), var(--d));
            border-radius: 3px;
            position: absolute;
            left: 0;
            bottom: -18px;
          }
        }
        .ability-item-text {
          margin-top: 38px;
          font-size: 14px;
          text-align: justify;
          line-height: 22px;
        }
        .ability-item-num {
          font-family: @font-bold;
          font-size: 218px;
          color: var(--s);
          position: absolute;
          bottom: -28px;
          right: -20px;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        &:hover {
          transform: translateY(-16px);
          .ability-item-title {
            color: #2177FF;
          }
          .ability-item-num {
            opacity: 0.15;
          }
        }
      }
    }
  }
}
</style>
